import React from 'react'

import classnames from 'classnames'
import PropTypes from 'prop-types'

import css from './NutritionDisclaimerText.css'

const NutritionDisclaimerText = ({ numPortions }) => (
  <div className={classnames(css.extraNutritionalInformation, css.extraInfoMargins)}>
    <div>
      <span>
        &#42;Gousto’s nutritional information only applies to ingredients supplied by Gousto. The
        cooking process and additional ingredients added at home (listed under “What you’ll need”)
        will affect total values.
      </span>
    </div>
    <div className={css.portionSizePadding}>
      <span>Portion sizes are based on the quantities used in a {numPortions} person box.</span>
    </div>
  </div>
)

NutritionDisclaimerText.propTypes = {
  numPortions: PropTypes.number.isRequired,
}

export { NutritionDisclaimerText }
